<template>
  <b-row align-h="center">
    <b-col cols="auto">
      <PieGraph
        :id="id"
        :items="items"
        @highlight="highlight($event)"
      />
    </b-col>
    <b-col cols="auto">
      <PieTable
        :id="id"
        :items="items"
        :show-percentages="showPercentages"
        :highlighted-row="highlightedRow"
      />
    </b-col>
  </b-row>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { GraphItem } from '@/components/public/GraphTable/GraphTableTotal.vue'

import PieGraph from '@/components/public/GraphTable/PieGraph.vue'
import PieTable from '@/components/public/GraphTable/PieTable.vue'

const components = {
  PieGraph,
  PieTable,
}
const props = {
  items: {
    type: Array as PropType<GraphItem[]>,
    default: () => [
      { title: 'Line1', value: 100, color: 'red' },
      { title: 'Line2', value: 50, color: 'blue' },
      { title: 'Line3', value: 25, color: 'green' },
    ],
  },
  id: {
    type: String,
    required: true,
  },
  showPercentages: {
    type: Boolean,
    default: false,
  },
}

@Component({ components })
export default class GraphTable extends Vue.extend({ props }) {
  highlightedRow: string | null = null

  highlight (row: string | null) {
    this.highlightedRow = row
    this.$root.$emit('bv::refresh::table', this.id)
  }
}
</script>
